import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "meet-our-talent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "body-text-lg text-w-bold title" }, " Meet our talent ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "body-text body" }, " Here’s a sample of the amazing talent you Augment your team with Submit a project request to access a pool of candidates based on your requirements. ", -1)
const _hoisted_4 = { class: "profile-cards-container grid-x" }
const _hoisted_5 = { class: "grid-x align-center new-project-button-container" }
const _hoisted_6 = { class: "cell small-12 medium-3 large-5 xlarge-6 xxlarge-4 x3large-3" }

import { ref } from 'vue'
import { NButton } from 'naive-ui'

import TalentProfileCard from "@/components/client/home/TalentProfileCard.vue";
import { TalentProfile } from "@/ts/interfaces"


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetOurTalent',
  setup(__props) {

const talents : TalentProfile[] = [
  {
    profilePicLink: "pictures/profile-picture-Rafael.png",
    name: "Rafael",
    // profileLink: "https://www.google.com/",
    mainSkills: ["OOP", "Full stack Application", "C++"],
    yearsOfExperience: 14,
    location: "Brazil",
    hourlyRate: 60,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  },
  {
    profilePicLink: "pictures/profile-picture-Tania.png",
    name: "Tania",
    // profileLink: "https://www.google.com/",
    mainSkills: ["Typescript", "Javascript", "ES2020"],
    yearsOfExperience: 12,
    location: "México",
    hourlyRate: 50,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  },
  {
    profilePicLink: "pictures/profile-picture-Marcos.png",
    name: "Marcos",
    // profileLink: "https://www.google.com/",
    mainSkills: ["Javascript", "Node.js", "Wordpress"],
    yearsOfExperience: 9,
    location: "México",
    hourlyRate: 50,
    about: "Experienced Software Engineer with a demonstrated history of working in the information technology and services industry. Skilled in OOP, Full Stack applications, C#, JS. Strong engineering professional with a Doctor of Philosophy - Ph.D. in Computer Engineering.",
    complementarySkills: ["Net Core", "Python", "NodeJS"],
    experience: [
      {
        job_position: "Team Lead Software Development",
        time_period: "July 2018 - Present"
      },
      {
        job_position: "Lead Developer",
        time_period: "February 2017 - June 2018"
      },
      {
        job_position: "Full-Stack Developer",
        time_period: "February 2012 - January 2017"
      },
      {
        job_position: "Mobile & Full-Stack Developer",
        time_period: "September 2010 - January 2011"
      }
    ]
  }
]

const cardExpanded = ref<null | number>(null)
const expandCard = (key: number) => cardExpanded.value = key

const closeCard = () => cardExpanded.value = null

const cardIsHidden = (key: number) => cardExpanded.value !== null && (key !== cardExpanded.value)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(talents, (talent, key) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["cell small-12 medium-6", cardExpanded.value != null ? 'large-12' : 'large-4']),
          key: key
        }, [
          _withDirectives(_createVNode(TalentProfileCard, _mergeProps(talent, {
            "is-expanded": key === cardExpanded.value,
            onExpandCard: ($event: any) => (expandCard(key)),
            onCloseCard: closeCard
          }), null, 16, ["is-expanded", "onExpandCard"]), [
            [_vShow, !cardIsHidden(key)]
          ])
        ], 2)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, { to: { name: 'client-project-create' } }, {
          default: _withCtx(() => [
            _createVNode(_unref(NButton), {
              class: "new-project-button",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SUBMIT NEW PROJECT ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})